<template>
    <div>
        <el-dialog title="文件上传" :visible.sync="dialogVS" :before-close="handleClose" width="700px">
            <div id="wrapper" >
                <div id="container">
                    <div id="uploader">
                        <div class="queueList">
                            <div id="dndArea" class="placeholder">
                                <div id="filePicker"></div>
                                <p id="p_info"></p>
                            </div>
                        </div>
                        <div class="statusBar" style="display:none;">
                            <div class="progressinfo">
                                <span class="text">0%</span>
                                <span class="percentage"></span>
                            </div>
                            <div class="info"></div>
                            <div class="btns">
                                <div id="checkbox"><label><input id="ip_compress" class="compress" type="checkbox" value="remember-me" checked="checked">压缩</label></div>
                                <div id="filePicker2"></div>
                                <div class="uploadBtn">开始上传</div>
                                <div id="btnCancel" class="commonbtn" style="margin-left:10px">关闭</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>    
    </div>
</template>
<style>
@import  "../../../static/WebUploader/style/uploader.style.css";
@import  "webuploader/css/webuploader.css";
#wrapper {
    margin: 0 auto;
    width: auto;
    margin: -20px 0;
}
#container {
    color: #838383;
    font-size: 12px;
    background-color: #FFF;
}
#uploader .queueList {
    margin: 20px;
}
.commonbtn {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
}
.ignore,
.retry {
    font-size: 12px;
    padding: 2px 6px;
    border-color: #eea236;
}
#btnCancel {
    color: #fff;
    background-color: #909399;
    border-color: #909399;
}
</style>

<script>
import WebUploader from 'webuploader' 
 export default {
    props: ['optionParam'],
    data(){
        return {
            dialogVS:false,
            Base_ParamConfig : {
                // proxyCoreServer: "http://192.168.0.107:8080//cy",        //上传附件的默认服务地址
                proxyCoreServer: this.URL_PREFIX+'irriproject/',              //上传附件的默认服务地址
                /*附件上传配置*/
                imageMaxSize:10,    //附件单个图片最大限制(MB)
                imageMinSize:5,    //附件单个最小限制(KB)
                imageLimit:20,    //附件-图片数量限制
                imageTypes:'jpg,png,bmp',    //附件-图片支持的类型
                docSize:30,        //附件- 文档单个大小MB
                docLimit:20,      //附件 -文档限制数量
                docTypes:'doc,docx,pdf,rar,zip,xlsx,txt'       //附件-文档支持的类型 
            },
            swfu: null,
            uploadUrl: "",         //附件上传的具体地址
            allowNum: 10,           //允许上传的最大数量
            _callback: null,       //上传后的回调函数  
            $wrap: null,
            $queue: null,

            // 状态栏，包括进度和控制按钮
            $statusBar: null,
            // 文件总体选择信息。
            $info: null,
            // 上传按钮
            $upload: null,
            //关闭按钮
            $closeBtn: null,
            // 没选择文件之前的内容。
            $placeHolder: null,
            // 总体进度条
            $progress: null,

            // 添加的文件数量
            fileCount: 0,

            // 添加的文件总大小
            fileSize: 0,


            // 优化retina, 在retina下这个值是2
            ratio: window.devicePixelRatio || 1,

            // 缩略图大小
            thumbnailWidth: 110 * this.ratio,
            thumbnailHeight: 110 * this.ratio,

            // 可能有pedding, ready, uploading, confirm, done.
            state: 'pedding',
            

            // 所有文件的进度信息，key为file id
            percentages: {},
            supportTransition: (function () {
                var s = document.createElement('p').style,
                    r = 'transition' in s ||
                        'WebkitTransition' in s ||
                        'MozTransition' in s ||
                        'msTransition' in s ||
                        'OTransition' in s;
                s = null;
                return r;
            })(),

            post_params: {
                affixtype: 0,         //0图片   1文件（调用时传入）
                uuid: '',             //附件id       （调用时传入） 
                fieldname:'',         //字段名       （调用时传入）  
                resourceid:'',        //表的uuid     （调用时传入） 
                folder_id:'',         //附件所在文件夹的uuid（若指定传到哪个文件夹中，该参数不可为空；若不指定，该参数为空，后台自动存入到默认文件夹中）（调用时传入）
                dataid:'',		      //该条记录的uuid     （调用时传入）
                userid:'',		      //该用户的uuid       （调用时传入）
                file_types: 'jpg,png,bmp,doc,docx,pdf,rar,zip,xlsx,txt',  //文件类型（默认值）
                file_size_limit: 1,                                       //（默认值） 
                file_compress: true,                                      //（默认值） 
                action: 'affixupload',                                    //（默认值） 

            },
            uploader: null
        }
    },
    methods: {
        //初始化参数
        initParams() {
            this.uploadUrl = this.Base_ParamConfig.proxyCoreServer + "fileupload.spring";             //附件上传地址
            if (!WebUploader.Uploader.support()) {
                alert('Web Uploader 不支持您的浏览器！如果你使用的是IE浏览器，请尝试升级 flash 播放器');
                throw new Error('WebUploader does not support the browser you are using.');
            }

            this.uploader = null;

            if (this.optionParam && this.optionParam.callback) {
                this._callback = this.optionParam.callback;
            }
            this.allowNum = this.optionParam.allowNum || (this.optionParam.affixtype ? this.Base_ParamConfig.docLimit:this.Base_ParamConfig.imageLimit);                   //允许上传的文件数量
            
            this.post_params.affixtype = this.optionParam.affixtype;     //0-图片  1-文档
            this.post_params.uuid = this.optionParam.uuid;
            this.post_params.fieldname = this.optionParam.fieldname || '';
            this.post_params.resourceid = this.optionParam.resourceid;
            this.post_params.folder_id = this.optionParam.folder_id;
            this.post_params.dataid = this.optionParam.dataid;
            this.post_params.userid = this.optionParam.userid;

            if (this.post_params.affixtype == 0) {
                this.post_params.file_types = this.Base_ParamConfig.imageTypes;//支持图片类型
                this.post_params.file_size_limit = this.Base_ParamConfig.imageMaxSize;
            } else {
                this.post_params.file_types = this.Base_ParamConfig.docTypes;//支持文档类型
                this.post_params.file_size_limit = this.Base_ParamConfig.docSize;
            }
        },
        uploaderLoad() {//uploader初始化
            this.initParams();      
            var info = "";
            var _this = this;
            if (this.post_params.affixtype == 0) {
                info = "支持"+this.Base_ParamConfig.imageTypes+"格式;单张大小"+ this.Base_ParamConfig.imageMinSize +"k~" + this.Base_ParamConfig.imageMaxSize + "MB;1M～5MB的图片可选择自动无损压缩;还可上传" + this.allowNum + "张图片";
                $("#dndArea").css("background-image", "url(static/webUploader/style/image_bg.png)");

            } else {
                info = "支持"+this.Base_ParamConfig.docTypes+"格式;单个大小不可超过" + this.Base_ParamConfig.docSize + "MB;还可上传" + this.allowNum + "个文档";
                $("#dndArea").css("background-image", "url(static/webUploader/style/file_bg.png)");
            }
            $("#p_info").html(info);
            this.$wrap = $('#uploader');
            this.$queue = $('<ul class="filelist"></ul>').appendTo(this.$wrap.find('.queueList'));

            this.$statusBar = this.$wrap.find('.statusBar');
            this.$info = this.$statusBar.find('.info');
            this.$upload = this.$wrap.find('.uploadBtn');
            this.$closeBtn = this.$wrap.find('#btnCancel');
            this.$placeHolder = this.$wrap.find('.placeholder');
            this.$progress = this.$statusBar.find('.progressinfo').hide(),

            this.uploader = WebUploader.create({
                version:new Date(),
                pick: {
                    id: '#filePicker',
                    label: this.post_params.affixtype == 0 ? '选择图片' : '选择文档'
                },
                dnd: '#uploader .queueList',
                //paste: document.body,//粘贴上传

                accept: {
                    title: this.post_params.affixtype == 0 ? '图片' : '文档',
                    extensions: this.post_params.file_types,
                    mimeTypes: '*'//this.post_params.affixtype == 0 ? 'image/*' : '*'//谷歌新版本浏览器 不推荐用 指定特定mime类型，不然打开文件框会让你抓狂  add by syd 2016-09-12 11:49:18
                },

                //swf文件路径--兼容ie6+  如果浏览器不支持H5上传 则用flash 上传
                swf: 'webuploader/dist/Uploader.swf',

                disableGlobalDnd: true,
                threads: 1,
                chunked: false,//是否要分片处理大文件上传
                compress:false,//不启用压缩
                formData: _this.post_params,
                server: _this.uploadUrl,
                fileNumLimit: _this.allowNum,
                //fileSizeLimit: 5 * 1024 * 1024,    // 5 M
                fileSingleSizeLimit: _this.post_params.file_size_limit * 1024 * 1024    // 限制单个文件大小M

            });

            this.uploader.addButton({
                id: '#filePicker2',
                label: '继续添加'
            });
            //上传过程中触发，携带上传进度
            this.uploader.onUploadProgress = function (file, percentage) {
                // debugger;
                var $li = $('#' + file.id),
                    $percent = $li.find('.progress span');

                $percent.css('width', percentage * 100 + '%');
                _this.percentages[file.id][1] = percentage;
                _this.updateTotalProgress();
            };
            //当文件被加入队列之前触发
            this.uploader.on('beforeFileQueued' , function (erro) {
                
            });
            //当一批文件添加进队列以后触发。
            this.uploader.on('fileQueued' , function (file) {
                console.log(file);
                _this.fileCount++;
                _this.fileSize += file.size;

                if (_this.fileCount === 1) {
                    _this.$placeHolder.addClass('element-invisible');
                    _this.$statusBar.show();
                }

                _this.addFile(file);
                if (_this.post_params.affixtype == 1){//文件类型
                    $("#checkbox").hide();
                }
                
                _this.setState('ready');
                _this.updateTotalProgress();
            });
            //当文件被移除队列后触发
            this.uploader.on('fileDequeued' , function (file) {
                _this.fileCount--;
                _this.fileSize -= file.size;

                if (!_this.fileCount) {
                    _this.setState('pedding');
                }

                _this.removeFile(file);
                _this.updateTotalProgress();

            });
            //监听所有
            this.uploader.on('all', function (type) {
                var stats;
                switch (type) {
                    case 'uploadFinished':
                        _this.setState('confirm');
                        break;

                    case 'startUpload':
                        _this.setState('uploading');
                        break;

                    case 'stopUpload':
                        _this.setState('paused');
                        break;

                }
            });
            //不管成功或者失败，所有文件上传完成时触发
            // this.uploader.on('uploadFinished', this._callback);//上传完成后的回调事件
            
            //某个文件开始上传前触发，一个文件只会触发一次
            this.uploader.on('uploadStart',function(file){
                console.log(file);
                if (_this.post_params.affixtype == 0){
                    _this.uploader.options.formData.file_compress=$("#ip_compress").is(':checked');//是否启用压缩
                }	
            });
            
            //当某个文件上传到服务端响应后，会派送此事件来询问服务端响应是否有效
            this.uploader.on('uploadAccept', function (obj, ret) {
                if (ret.code == 0) {
                    _this.$message({
                        message: ret.message,
                        type: 'warning'
                    });
                    return false;
                } else if(ret.code==100||ret.code==101){
                    _this.$message({
                        message: ret.message,
                        type: 'warning'
                    });
                    var myVar = setInterval(function () {
                        //window.location.href = "login.html";
                        L.hh.app.service.logout();//注销返回login.html
                        window.clearInterval(myVar);
                    }, 1500);
                    
                }else {
                    return true;
                }

            });
            //每个文件上传成功之后触发
            this.uploader.on('uploadSuccess', function (file, response) {
                console.log(response.result)
                if(response.code==0){//上传失败时触发
                    _this.$message({
                        message: response.message||'上传失败！',
                        type: 'warning'
                    });                   
                }else {
                    // console.log(1111)
                    // console.log(response.result)
                    _this._callback(response.result);
                }
                
            });
            
            //不管成功或者失败，文件上传完成时触发
            this.uploader.on('error' , function (code) {
                console.log(code);
                if (code == "Q_EXCEED_NUM_LIMIT") {
                    _this.$message({
                        message: "文件数量超出最大限制",
                        type: 'warning'
                    });
                } else if (code == "Q_EXCEED_SIZE_LIMIT" || code == 'F_EXCEED_SIZE') {
                    _this.$message({
                        message: "文件大小超出最大限制",
                        type: 'warning'
                    });
                } else if(code == "Q_TYPE_DENIED") {
                    _this.$message({
                        message: "文件类型不满足",
                        type: 'warning'
                    });
                }


            });
            //点击上传按钮
            this.$upload.on('click', function () {
                if ($(this).hasClass('disabled')) {
                    return false;
                }
                console.log(_this.state);
                if (_this.state === 'ready') {
                    _this.uploader.upload();
                } else if (this.state === 'paused') {
                    _this.uploader.upload();
                } else if (this.state === 'uploading') {
                    _this.uploader.stop();
                }
            });
            //关闭弹窗
            this.$closeBtn.on('click',function (){
                _this.closeset();
            })
            //点击重新上传
            this.$info.on('click', '.retry', function () {
                _this.uploader.retry();
            });
            //上传失败忽略 点击事件
            this.$info.on('click', '.ignore', function () {
                //alert('todo');
            });

            this.$upload.addClass('state-' + this.state);
            this.updateTotalProgress();
        },
        addFile(file) {
            var _this = this;
            var rotatehtml = '';
            var text = '';
            if (this.post_params.affixtype == 0) {//图片
                rotatehtml = '<span class="rotateRight">向右旋转</span><span class="rotateLeft">向左旋转</span>';
                if(file.size/1024 < this.Base_ParamConfig.imageMinSize){
                    file.setStatus('invalid',"less_size" );
                }
            }
            var $li = $('<li id="' + file.id + '">' +
                    '<p class="title" title="' + file.name + '">' + file.name + '</p>' +
                    '<p class="imgWrap"></p>' +
                    '<p class="fileprogress"><span></span></p>' +
                    '</li>'),

                $btns = $('<div class="file-panel">' +
                    '<span class="cancel">删除</span>' + rotatehtml + '</div>').appendTo($li),
                $prgress = $li.find('p.progress span'),
                $wrap = $li.find('p.imgWrap'),
                $info = $('<p class="error"></p>'),

                showError = function (code) {
                    switch (code) {
                        case 'exceed_size':
                            text = '文件大小超出';
                            break;

                        case 'interrupt':
                            text = '上传暂停';
                            break;
                        case 'less_size':
                            text = '文件大小不足';
                            break;
                        default:
                            text = "上传失败，请重试";
                            break;
                    }

                    $info.text(text).appendTo($li);
                };
        
            if (file.getStatus() === 'invalid') {
                showError(file.statusText);
            } else {
                $wrap.text('预览中');

                if (this.post_params.affixtype == 0) {
                    //如果是图片 生成缩略图
                    this.uploader.makeThumb(file, function (error, src) {
                        if (error) {
                            $wrap.text('不能预览');
                            return;
                        }

                        var img = $('<img src="' + src + '">');
                        $wrap.empty().append(img);
                    }, this.thumbnailWidth, this.thumbnailHeight);
                } else {
                    //文档不生成缩略图
                    var ext = file.ext;
                    var img;
                    if (ext == "doc") {
                        img = $('<img src="static/webUploader/style/file_doc.png">');
                    } else if (ext == "docx" || ext == "xlsx") {
                        img = $('<img src="static/webUploader/style/file_common.png">');
                    } else if (ext == "pdf") {
                        img = $('<img src="static/webUploader/style/file_pdf.png">');
                    } else {
                        img = $('<img src="static/webUploader/style/file_common.png">');
                    }

                    $wrap.empty().append(img);
                }


                this.percentages[file.id] = [file.size, 0];
                file.rotation = 0;
            }

            file.on('statuschange', function (cur, prev) {
                // debugger;
                console.log(cur);
                if (prev === 'progress') {
                    $prgress.hide().width(0);
                } else if (prev === 'queued') {
                    $li.off('mouseenter mouseleave');
                    $btns.remove();
                }

                // 成功
                if (cur === 'error' || cur === 'invalid') {
                    showError(file.statusText);
                    _this.percentages[file.id][1] = 1;
                } else if (cur === 'interrupt') {
                    showError('interrupt');
                } else if (cur === 'queued') {
                    _this.percentages[file.id][1] = 0;
                } else if (cur === 'progress') {
                    $info.remove();
                    $prgress.css('display', 'block');
                } 
                else if (cur === 'complete') {
                    $li.append('<span class="success"></span>');
                }

                $li.removeClass('state-' + prev).addClass('state-' + cur);
            });

            $li.on('mouseenter', function () {
                $btns.stop().animate({ height: 30 });
            });

            $li.on('mouseleave', function () {
                $btns.stop().animate({ height: 0 });
            });

            $btns.on('click', 'span', function () {
                var index = $(this).index(),
                    deg;

                switch (index) {
                    case 0:
                        _this.uploader.removeFile(file);
                        return;

                    case 1:
                        file.rotation += 90;
                        break;

                    case 2:
                        file.rotation -= 90;
                        break;
                }

                if (_this.supportTransition) {
                    deg = 'rotate(' + file.rotation + 'deg)';
                    $wrap.css({
                        '-webkit-transform': deg,
                        '-mos-transform': deg,
                        '-o-transform': deg,
                        'transform': deg
                    });
                } else {
                    $wrap.css('filter', 'progid:DXImageTransform.Microsoft.BasicImage(rotation=' + (~~((file.rotation / 90) % 4 + 4) % 4) + ')');
                }


            });

            $li.appendTo(this.$queue);

        },
        //从队列中删除文件
        removeFile(file) {
            var $li = $('#' + file.id);

            delete this.percentages[file.id];
            this.updateTotalProgress();
            $li.off().find('.file-panel').off().end().remove();
        },
        //清除所有文件队列
        removeAllfiles() {
            for(var i = 0 , ilen = this.uploader.getFiles().length ; i < ilen ; i++) {
                this.uploader.removeFile(this.uploader.getFiles()[i]);
            }
        },
        updateTotalProgress() {
            var loaded = 0,
            total = 0,
            spans = this.$progress.children(),
            percent;

            $.each(this.percentages, function (k, v) {
                total += v[0];
                loaded += v[0] * v[1];
            });

            percent = total ? loaded / total : 0;

            spans.eq(0).text(Math.round(percent * 100) + '%');
            spans.eq(1).css('width', Math.round(percent * 100) + '%');
            this.updateStatus();
        },

        updateStatus() {

            var text = '', stats;
            var name = this.post_params.affixtype == 0 ? '张图片' : '个文档';
            if (this.state === 'ready') {
                text = '选中' + this.fileCount + name + '，共' +
                        WebUploader.formatSize(this.fileSize) + '。';
            } else if (this.state === 'confirm') {
                stats = this.uploader.getStats();
                if (stats.uploadFailNum) {
                    text = '已成功上传' + stats.successNum + name + '上传至附件，' +
                        stats.uploadFailNum + name + '上传失败，<a class="retry commonbtn" href="javascript:void(0);">重新上传</a>失败文件或<a class="ignore commonbtn    " href="javascript:void(0);">忽略</a>'
                }

            } else {
                stats = this.uploader.getStats();
                text = '共' + this.fileCount + '个（' +
                        WebUploader.formatSize(this.fileSize) +
                        '），已上传' + stats.successNum + '个';

                if (stats.uploadFailNum) {
                    text += '，失败' + stats.uploadFailNum + '个';
                }
            }

            if (this.fileCount == this.allowNum) {
                // debugger;
                // this.$upload.text('开始上传').addClass('disabled');
                $('#filePicker2').hide();
            } else if (this.fileCount < this.allowNum) {
                $('#filePicker2').show();
            }

            this.$info.html(text);
        },
        setState(val) {
            var file, stats;

            if (val === this.state) {
                return;
            }
            this.$upload.removeClass('state-' + this.state);
            this.$upload.addClass('state-' + val);
            this.state = val;
            switch (this.state) {
                case 'pedding':
                    this.$placeHolder.removeClass('element-invisible');
                    this.$queue.parent().removeClass('filled');
                    this.$queue.hide();
                    this.$statusBar.addClass('element-invisible');

                    this.uploader.refresh();
                    break;

                case 'ready':
                    this.$placeHolder.addClass('element-invisible');
                    $('#filePicker2').removeClass('element-invisible');
                    //$('#btnCancel').removeClass('element-invisible');
                    this.$queue.parent().addClass('filled');
                    this.$queue.show();
                    this.$statusBar.removeClass('element-invisible');
                    this.uploader.refresh();
                    break;

                case 'uploading':
                    //$('#filePicker2').addClass('element-invisible');
                    //$('#btnCancel').addClass('element-invisible');
                    //this.$upload.hide();

                    this.$progress.show();
                    this.$upload.text('暂停上传');
                    break;

                case 'paused':
                    this.$progress.show();
                    this.$upload.text('继续上传');
                    break;

                case 'confirm':

                    this.$progress.hide();

                    if (this.fileCount == this.allowNum) {
                        // debugger;
                        // this.$upload.text('开始上传').addClass('disabled');
                    } else {
                        this.$upload.text('开始上传');
                    }

                    //$('#btnCancel').removeClass('element-invisible');


                    stats = this.uploader.getStats();
                    if (stats.successNum && !stats.uploadFailNum) {
                        this.setState('finish');
                        return;
                    }
                    break;
                case 'finish':
                    stats = this.uploader.getStats();
                    if (stats.successNum) {

                        //alert('上传成功');

                    } else {
                        // 没有成功的图片，重设
                        this.state = 'done';
                        location.reload();
                    }
                    this.uploader.refresh();
                    break;
            }

            this.updateStatus();
        },
        handleClose(done) {           
            done();
            this.closeset();                      
        },
        closeset() {
            this.optionParam.dialogVS = false;
            this.removeAllfiles();
            this.setState('confirm');
            this.fileCount = 0,
            this.fileSize = 0;
        },
        showDialog() {
            var _this = this;
            this.dialogVS = true;
            this.$nextTick(function (){
                _this.uploaderLoad();
            })
        }
    },
    mounted(){
        var _this = this;
    }

    }
</script> 


// WEBPACK FOOTER //
// src/components/commomUploader/webuploaerceshi.vue